module.exports = __webpack_public_path__ + "static/img/no-avatar.88962eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/no-avatar.jpg
// module id = 381
// module chunks = 4